<template>
    <div>
        <h2 class="courseSelector__headline">
            {{ $t(title) }}<span class="form__required-indicator">*</span>
        </h2>
        <div class="courseSelector__selector" v-for="selectedCourse, index in selectedCourses[selectedIndex]" :key="index">
            <select class="courseSelector__select"
                :class="courseTypeError ? 'courseSelector__select--error' : ''"
                :aria-label="$t('courseSelection')"
                name=""
                :id="'selectedCourse_' + selectedIndex + '_' + index"
                required
                v-on:change="updateSelectedCourses($event, index)">

                <option class="courseSelector__option" value="0" selected>{{ $t(defaultOption)}} {{ index +1 }}. {{ $t("choice")}}</option>
                <option class="courseSelector__option"
                    v-for="course in courses"
                    :key="course.id"
                    :value="course.id"
                    :disabled="courseIsDisabled(course)"
                    :selected="selectedCourse == course.id">
                    {{ getCourseName(course.id) }}
                </option>
            </select>
        </div>
        <div class="courseSelector__error" v-if="courseTypeError">{{ courseTypeError }}</div>
        <div v-if="showAddCourse()">
            <button class="form__input-add-button"
                v-on:click="addCourse(1)">{{$t("formButtonAddCourse")}}</button>
            <div>
                <span class="form__explanation">
                    {{$t('formExplanationCourse')}}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'title',
        'defaultOption',
        'courses',
        'locale',
        'selectedCourses',
        'courseTypeError',
        'selectedIndex'
    ],
    emits: [
        'updateSelectedCourseList'
    ],
    methods: {
        addCourse(index) {
            const maxLength = Math.min(this.courses.length, 4);
            if (this.selectedCourses[this.selectedIndex].length == maxLength) {
                return;
            }

            this.selectedCourses[this.selectedIndex].push(0);
        },
        courseIsDisabled(course){
            return (
                this.selectedCourses[this.selectedIndex].includes(course.id) ||
                course.booking_status.id === 1
            );
        },
        updateSelectedCourses(event = null, index = null) {
            if (event) {
                const select = event.target;
                const i      = parseInt(select.id.split('_')[1]);
                const course = select.value;
                if (index !== null
                    && this.selectedCourses[index] !== null
                    && this.selectedCourses[index] != parseInt(course)) {
                    this.selectedCourses[this.selectedIndex][index] = parseInt(course);
                } else if (!this.selectedCourses[this.selectedIndex].includes(parseInt(course))) {
                    this.selectedCourses[this.selectedIndex].push(parseInt(course));
                }
            }

            this.$emit('updateSelectedCourseList', this.selectedCourses);
        },
        getCourseName(courseId) {
            let course = null;
            course = this.courses.find(course => course.id == courseId);

            // Set status message if course booking_status is not open.
            let statusMsg = "";
            if(course.booking_status.id != 0){
                if(this.locale === "no"){
                    statusMsg = " (" + course.booking_status.name_no + ")"
                } else {
                    statusMsg = " (" + course.booking_status.name_en + ")"
                }
            }

            // set name of course
            let courseName = "";
            if (this.locale === "no") {
                courseName = course.name_no;
            } else {
                courseName = course.name_en;
                if (courseName === null || courseName === "") {
                    courseName = course.name_no;
                }
            }

            return courseName + statusMsg;
        },
        showAddCourse() {
            const maxLength = Math.min(this.courses.length, 4);
            return this.selectedCourses[this.selectedIndex].length < maxLength;
        },
    },
    computed: {

    },
    watch: {

    }
}
</script>